import React from "react";
import { Download, Plus, SlidersHorizontal, ChevronDown } from "lucide-react";
import { STATUS_LIST } from "../batchAdapters";

const BatchToolbar = ({ statusFilter, onStatusFilterChange, onExport, isExporting,
  onAddClick, addLabel = "Add New Batch", canAdd = true, filtersOpen, onToggleFilters, hasFilters }) => (
  <div className="flex flex-col gap-3 pb-4 sm:flex-row sm:items-center sm:justify-between">
    <h1 className="text-2xl font-semibold text-slate-900">Batch List</h1>
    <div className="flex flex-col gap-2.5 sm:flex-row sm:flex-wrap sm:items-center sm:justify-end">
      <select aria-label="Batch status" value={statusFilter} onChange={(event) => onStatusFilterChange(event.target.value)}
        className="h-10 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-600">
        <option value="">All statuses</option>
        {STATUS_LIST.map((status) => <option key={status} value={status}>{status}</option>)}
      </select>
      <button type="button" onClick={onExport} disabled={isExporting}
        className="inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-brand/30 bg-white px-3.5 text-sm font-medium text-brand transition-colors hover:bg-lightSecondary disabled:opacity-50">
        <Download className="h-4 w-4" />{isExporting ? "Exporting…" : "Export"}
      </button>
      <button type="button" onClick={onAddClick} disabled={!canAdd}
        title={!canAdd ? "Select a plant from the top bar first" : undefined}
        className="inline-flex h-10 items-center justify-center gap-2 rounded-lg bg-brand px-3.5 text-sm font-medium text-white shadow-sm transition-colors hover:bg-brandDark disabled:cursor-not-allowed disabled:opacity-50">
        <Plus className="h-4 w-4" />{addLabel}
      </button>
      <button type="button" onClick={onToggleFilters} aria-expanded={filtersOpen}
        className="inline-flex h-10 items-center justify-center gap-2 rounded-lg border border-slate-200 bg-white px-3.5 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-50">
        <SlidersHorizontal className="h-4 w-4" />Filter{hasFilters && <span className="h-2 w-2 rounded-full bg-brand" aria-label="Filters active" />}<ChevronDown className="h-3.5 w-3.5" />
      </button>
    </div>
  </div>
);

export default BatchToolbar;
